import * as React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './NotAuthorizedPageContent.scss'

export const NotAuthorizedPageContent = () => {
  return (
    <Container className='d-flex flex-column align-items-center justify-content-center not-authorized-container'>
      <Row className='p-0'>
        <Col className='text-center'>
          <div className='not-authorized-icon-wrapper zocks-bg-color-primary-light d-inline-flex align-items-center justify-content-center rounded-circle mb-4'>
            <i className='bi bi-shield-lock zocks-text-primary' />
          </div>
        </Col>
      </Row>
      <Row>
        <Col className='text-center'>
          <h2 className='zocks-text-gray-900 mb-3'>Access Denied</h2>
          <p className='paragraph-large zocks-text-gray-900 mb-2'>You don't have permission to view this page.</p>
          <p className='paragraph-small zocks-text-gray-600 not-authorized-description'>
            This might be because your account doesn't have the required permissions, or the resource has been restricted. If you believe this is an error,
            please contact your administrator or the person who shared this link with you.
          </p>
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col className='text-center'>
          <p className='paragraph-small zocks-text-gray-600 mb-0'>
            <i className='bi bi-question-circle me-1' />
            Need help? Contact your system administrator for assistance.
          </p>
        </Col>
      </Row>
    </Container>
  )
}
